const React = require('react');

const { Breadcrumb, BreadcrumbLevel } = require('@andes/breadcrumb');

const { getTranslationsBySite } = require('@pages/V2/translations');

const { FILTERS_IDS } = require('@pages/V2/utils/constants');
const { buildUrl } = require('@pages/V2/utils/clientUtils');

const CategoriesBreadcrumb = ({ pathFromRoot, actualLocation, siteId }) => {
  const { filters } = getTranslationsBySite(siteId);
  const categoriesBreadcrumb = [{ id: '', name: filters.categoriesBreadcrumbDefault, addQueryParam: false }].concat(
    pathFromRoot,
  );
  return (
    pathFromRoot?.length > 0 && (
      <Breadcrumb srLabel="List of pages">
        {categoriesBreadcrumb?.map(({ id, name, addQueryParam = true }) => {
          return (
            <BreadcrumbLevel
              key={id}
              text={name}
              title={name}
              href={buildUrl({ actualLocation, filterId: FILTERS_IDS.CATEGORY, filterValueId: id, addQueryParam })}
            />
          );
        })}
      </Breadcrumb>
    )
  );
};

module.exports = CategoriesBreadcrumb;
